import React from 'react';
import { Patient } from 'types/types';
import { formatPhoneNumber } from 'utils/utils';
import Button from '../../Button/Button';
import Graphic from '../../Graphic/Graphic';
import Modal from '../Modal';

type ModalProps = {
  call: 'VOICE' | 'VIDEO';
  patient: Patient;
  onCloseModal: () => void;
  onStartVideoCall: () => void;
};

function CallPrompt({ patient, call, onCloseModal, onStartVideoCall }: ModalProps) {
  return (
    <Modal onClose={onCloseModal} show>
      <div className="rounded-xl bg-white tablet:w-[500px]">
        <div className="bg-[#FFE0AF] rounded-t-xl h-[200px] relative">
          <Graphic
            id="graphicVideoCall"
            className="absolute left-0 rounded-t-xl object-center object-cover 
            w-full h-[200px]"
          />
        </div>
        <div className="flex flex-col p-8 pt-8 pb-10">
          <h3 className="text-lg font-semibold mb-2 inline-flex whitespace-pre">
            {call === 'VIDEO' ? 'Start Video Call' : 'Start Voice Call'}
          </h3>

          {call === 'VIDEO' ? (
            <p className="mb-2 font-normal">
              You&apos;re about to invite {patient.firstName || 'patient'} to a video chat. Click on{' '}
              <strong>Continue</strong> to proceed.
            </p>
          ) : (
            <p>
              You&apos;re about to call {patient.firstName || 'patient'} on{' '}
              <strong>{formatPhoneNumber(patient.phoneNumber || '')}</strong> to start a voice chat.
              Click on Continue to proceed.
            </p>
          )}

          <div className="mt-8 text-center">
            <Button
              label="Continue"
              onClick={onStartVideoCall}
              className="w-[200px] !rounded-full !px-5 !py-[10px] !text-sm"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default CallPrompt;
